export default "__VITE_ASSET__Bw40HLno__"